import React from 'react'
import PropTypes from 'prop-types'
import { classNames as cn } from 'helpers'
import styles from './ArrowButton.module.scss'
import { ReactComponent as Arrow } from 'components/UI/icons/left-cycle.svg'

function ArrowButton({ left, onClick, isDisabled }) {
  return (
    <span
      type='button'
      data-arrow={left ? 'left' : 'right'}
      className={cn({
        [styles.base]: true,
        [styles.left]: left,
        [styles.disabled]: isDisabled,
      })}
      onClick={isDisabled ? null : onClick}
    >
      <Arrow />
    </span>
  )
}

ArrowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  left: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

ArrowButton.defaultProps = {
  left: false,
  isDisabled: false,
}

export default ArrowButton
